/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/alt-text */

import React, { useState, useRef } from "react";
import "./MyStyles/style.css";
import "./MyStyles/mobile-style.css";
import "./MyStyles/site.css";
import "./MyStyles/site2.css";
import ReCAPTCHA from "react-google-recaptcha";
import swal from "sweetalert";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

const siteKey = "6LdRA-coAAAAAA2ZbIqrk-n__N3yx6TMwee1ydmT"; // Replace with your actual site key

const apiBaseURL = process.env.REACT_APP_API_URL || `${window.location.origin}`;

export const BecomeOurPartner = () => {
  const recaptchaRef = useRef(null);
  const nameRef = useRef(null);
  const mobNoRef = useRef(null);
  const emailRef = useRef(null);
  const organizationRef = useRef(null);
  const gstRef = useRef(null);
  const queryRef = useRef(null);

  const [formData, setFormData] = useState({
    Name: "",
    EmailId: "",
    MobileNumber: "",
    Query: "",
    GSTNumber: "",
    OrganizationName: "",
    IPAddress: "",
  });

  const [consent, setConsent] = useState(true); // Checkbox value
  const [btnInitclr, setBtnInitclr] = useState(true); // Checkbox value
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    // Basic validation example (customize as needed)
    let errorMessage = "";
    const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/; // Regex to detect special characters

    switch (name) {
      case "Name":
        if (!value) {
          errorMessage = "* This is a required field.";
        } else if (specialCharRegex.test(value)) {
          errorMessage =
            "* Special character should not be entered in Name field.";
        }
        break;
      case "MobileNumber":
        if (!value) {
          errorMessage = "* This is a required field.";
        } else {
          errorMessage = /^[6-9]\d{9}$/.test(value)
            ? ""
            : "* Please enter a valid 10-digit mobile number"; ///^[6-9]\d{9}$/
        }
        break;
      case "EmailId":
        if (!value) {
          errorMessage = "* This is a required field.";
        } else {
          errorMessage =
            /^[^@\s]+@[^@\s]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/.test(value)
              ? ""
              : "* Please enter a valid email address";
        }
        break;
      case "OrganizationName":
        if (!value) {
          errorMessage = "* This is a required field.";
        } else if (specialCharRegex.test(value)) {
          errorMessage =
            "* Special character should not be entered in Organization field.";
        }
        break;
      case "GSTNumber":
        if (!value) {
          errorMessage = "* This is a required field.";
        } else {
          errorMessage =
            /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(
              value,
            )
              ? ""
              : "* Please enter a valid GST Number";
        }
        break;
      case "Query":
        if (!value) {
          errorMessage = "* This is a required field.";
        } else {
          errorMessage =
            value.length <= 500 ? "" : "* Query must be within 500 characters";
        }
        break;
      default:
        break;
    }

    // Update the errors object with the new error message
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: errorMessage,
    }));
  };

  // Handle consent checkbox change
  const handleConsentChange = (e) => {
    setConsent(e.target.checked);
    setBtnInitclr((prv) => (prv ? !prv : prv));
  };
  // Handle reCAPTCHA verification
  const onRecaptchaChange = (token) => {
    if (!token) {
      console.error("No token generated by reCAPTCHA.");
      recaptchaRef.current.reset();
      return;
    }
    // this Captchatoken use in controller page for captcha verify
    let myFormData = { ...formData, CaptchaRes: token };
    setFormData(myFormData);
  };

  const handleReset = () => {
    setFormData({
      Name: "",
      EmailId: "",
      MobileNumber: "",
      Query: "",
      GSTNumber: "",
      OrganizationName: "",
      IPAddress: "",
    });
    recaptchaRef.current.reset();
    setErrors({});
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const newErrors = { ...errors };

    if (!formData.Name) newErrors.Name = "* This is a required field.";
    if (!formData.MobileNumber)
      newErrors.MobileNumber = "* This is a required field.";
    if (!formData.EmailId) newErrors.EmailId = "* This is a required field.";
    if (!formData.OrganizationName)
      newErrors.OrganizationName = "* This is a required field.";
    if (!formData.GSTNumber)
      newErrors.GSTNumber = "* This is a required field.";
    if (!formData.Query) newErrors.Query = "* This is a required field.";

    // Set the merged errors without overwriting any existing errors
    setErrors(newErrors);

    // Check if there are any errors
    const hasErrors = Object.values(newErrors).some((error) => error);

    if (hasErrors) {
      if (errors.Name)
        nameRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      else if (errors.MobileNumber)
        mobNoRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      else if (errors.EmailId)
        emailRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      else if (errors.OrganizationName)
        organizationRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      else if (errors.GSTNumber)
        gstRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      else if (errors.Query)
        queryRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });

      setLoading(false);
      return; // Stop further processing if there are validation errors
    }

    if (!formData.CaptchaRes) {
      alert("Please complete the reCAPTCHA.");
      recaptchaRef.current?.reset();
      setLoading(false);
      return;
    }

    if (!consent) {
      alert("You must agree to the Code of Conduct.");

      setLoading(false);
      return;
    }

    try {
      const { CaptchaRes, ...restData } = formData;
      const myData = {
        ...restData,
        Platform: "watcho",
      };

      const response = await fetch(
        `${apiBaseURL}/api/WebAncillary/SubmitForm`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${CaptchaRes}`,
          },
          body: JSON.stringify(myData),
        },
      );
      if (response.ok) {
        const result = await response.json(); // Parse the JSON response
        if (result.resultCode === 0) {
          // Handle success
          swal({
            title: "Done",
            text: result.resultDesc,
            icon: "success",
            buttons: {
              confirm: {
                text: "OK",
                value: true,
                visible: true,
                className: "",
                closeModal: true,
              },
            },
          }).then(() => {
            window.location.reload();
          });

          window.scrollTo(0, 2);
        } else if (result.resultCode !== 0) {
          window.scrollTo(0, 2);

          swal({
            title: "",
            text: result.resultDesc,
            icon: "error",
            buttons: {
              confirm: {
                text: "OK",
                value: true,
                visible: true,
                className: "",
                closeModal: true,
              },
            },
          });
        }
      }
    } catch (error) {
      // Handle any other errors (e.g., network errors)
    } finally {
      setLoading(false);
      recaptchaRef.current.reset(); // Reset reCAPTCHA on error
    }
  };

  // Handle reCAPTCHA expiration
  const handleRecaptchaExpired = () => {
    console.error("Captcha expired. Please complete it again.");
    if (recaptchaRef.current) recaptchaRef.current.reset();
  };

  // Handle reCAPTCHA error
  const handleRecaptchaErrored = () => {
    console.error("An error occurred with reCAPTCHA. Please try again.");
    if (recaptchaRef.current) recaptchaRef.current.reset();
  };

  const OnlyNumeric = (e) => {
    let value = e.target.value;
    let numbers = value.replace(/[^0-9]/g, "");
    e.target.value = numbers;
  };

  const handleClose = () => {
    setLoading(false);
  };

  return (
    <>
      <div className="alignment-main-content">
        <div>
          <Backdrop
            sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
            open={loading}
            onClick={handleClose}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <form
            noValidate
            onSubmit={handleSubmit}
            id="formpartnerLead"
            className="form-box"
          >
            <div className="form-div">
              <div className="group">
                <div className="form-group div_align">
                  <div className="box">
                    <div className="label">
                      {" "}
                      <label htmlFor="Name">Name<span className="text-danger">*</span></label>
                    </div>
                    <div className="element">
                      <input
                        ref={nameRef}
                        type="text"
                        name="Name"
                        id="txtName"
                        required
                        placeholder="Name"
                        maxLength="30"
                        className="input-style"
                        value={formData.Name}
                        onChange={handleChange}
                        autoComplete="off"
                      />
                    </div>
                  </div>
                  <span className="text-danger error-span">{errors.Name}</span>
                </div>
                <div className="form-group div_align">
                  <div className="box">
                    <div className="label">
                      <label htmlFor="MobileNumber">Mobile Number<span className="text-danger">*</span></label>
                    </div>
                    <div className="element">
                      <input
                        name="MobileNumber"
                        ref={mobNoRef}
                        type="text"
                        id="txtMobileNo"
                        required
                        placeholder="10 digit number"
                        className="input-style"
                        value={formData.MobileNumber}
                        onChange={handleChange}
                        onInput={OnlyNumeric}
                        autoComplete="off"
                      />
                    </div>
                  </div>
                  <span className="error-span text-danger">
                    {errors.MobileNumber}{" "}
                  </span>
                </div>
              </div>
              <div className="group">
                <div className="form-group div_align">
                  <div className="box">
                    <div className="label">
                      <label htmlFor="EmailId">Email Address<span className="text-danger">*</span></label>
                    </div>
                    <div className="element">
                      <input
                        name="EmailId"
                        ref={emailRef}
                        type="email"
                        id="txtEmailId"
                        maxLength="30"
                        required
                        placeholder="Email Address"
                        className="input-style"
                        value={formData.EmailId}
                        onChange={handleChange}
                        autoComplete="off"
                      />
                    </div>
                  </div>
                  <span className="error-span text-danger">
                    {errors.EmailId}
                  </span>
                </div>
                <div className="form-group div_align">
                  <div className="box">
                    <div className="label">
                      <label htmlFor="OrganizationName">Organization<span className="text-danger">*</span></label>
                    </div>
                    <div className="element">
                      <input
                        name="OrganizationName"
                        ref={organizationRef}
                        type="text"
                        id="txtOrganizationName"
                        maxLength="20"
                        required
                        placeholder="Organization Name"
                        className="input-style"
                        value={formData.OrganizationName}
                        onChange={handleChange}
                        autoComplete="off"
                      />
                    </div>
                  </div>
                  <span className="error-span text-danger">
                    {errors.OrganizationName}
                  </span>
                </div>
              </div>
              <div className="group">
                <div className="form-group div_align">
                  <div className="box single-ele">
                    <div className="label">
                      <label htmlFor="GSTNumber">GST Number<span className="text-danger">*</span></label>
                    </div>
                    <div className="element">
                      <input
                        name="GSTNumber"
                        ref={gstRef}
                        type="text"
                        id="txtGSTNo"
                        required
                        maxLength="15"
                        placeholder="Enter Your GST Number"
                        className="input-style"
                        value={formData.GSTNumber}
                        onChange={handleChange}
                        autoComplete="off"
                      />
                    </div>
                  </div>
                  <span className="error-span text-danger">
                    {errors.GSTNumber}
                  </span>
                </div>
              </div>
              <div>
                <div className="form-group div_align">
                  <div className="box">
                    <div className="label">
                      <label htmlFor="Query">Request/Query Details<span className="text-danger">*</span></label>
                    </div>
                    <div className="element">
                      <textarea
                        ref={queryRef}
                        htmlFor="Query"
                        name="Query"
                        placeholder="Query only 500 characters are allowed"
                        maxLength="500"
                        className="input-style"
                        value={formData.Query}
                        onChange={handleChange}
                        autoComplete="off"
                        required
                        id="txtQuery"
                        rows="3"
                      ></textarea>
                    </div>
                  </div>
                  <span className="error-span text-danger">
                    {errors.Query}{" "}
                  </span>
                </div>
              </div>
              <div>
                <ReCAPTCHA
                  ref={recaptchaRef}
                  sitekey={siteKey} // Replace this with your Google reCAPTCHA Site Key
                  onChange={onRecaptchaChange}
                  onExpired={handleRecaptchaExpired}
                  onErrored={handleRecaptchaErrored}
                  theme="dark"
                  style={{ display: "inline-block", marginRight: "10px" }}
                />
              </div>
              <div className="group">
                <div className="concent-box ">
                  <input
                    type="checkbox"
                    className="larger"
                    id="concent-check"
                    checked={consent}
                    onChange={handleConsentChange}
                  />
                  <label htmlFor="concent-check">
                    <p>
                      By submitting this information, <br />I agree to abide by
                      the
                      <a
                        href="/CodeOfConductPDF/Dish_Infra_CoC _ Business&Partners.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        &nbsp;Code of Conduct
                      </a>
                    </p>
                  </label>
                </div>
              </div>
              <div className="group btn-box">
                <button
                  className="btn-class"
                  id="btnreset"
                  type="button"
                  onClick={handleReset}
                >
                  Reset
                </button>
                <button
                  className="btn-class btn-color"
                  type="submit"
                  id="btnsubmit"
                  disabled={!consent}
                  style={{
                    backgroundColor:
                      consent && btnInitclr
                        ? "#fec00f"
                        : consent
                          ? "#198754"
                          : "#6C757D", // Yellow if verified, grey if not
                    color: "#1e1e1e", // Dark text color
                    border: "none",
                    cursor: consent ? "pointer" : "not-allowed", // Show appropriate cursor
                  }}
                >
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};
